// src/components/home/UseCases.js
// Homepage strip of concrete key use cases.
import React from 'react';
import { useTranslation } from 'react-i18next';
import SectionTitle from '../SectionTitle';

const UseCases = () => {
    const { t } = useTranslation();
    const items = t('home.use_cases.items', { returnObjects: true }) || [];

    return (
        <div className="bg-gray-100 py-12">
            <section data-aos="fade-up">
                <SectionTitle title={t('home.use_cases.title')} />
                <div className="max-w-6xl mx-auto px-4 sm:px-8 mt-6">
                    <div className="grid sm:grid-cols-1 md:grid-cols-2 gap-4">
                        {Array.isArray(items) && items.map((item, i) => (
                            <div key={i} className="flex items-start bg-white rounded-lg shadow p-4" data-aos="fade-up" data-aos-delay={i * 75}>
                                <svg className="w-6 h-6 text-primary flex-shrink-0 mt-0.5" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" aria-hidden="true">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                                <p className="ml-3 text-gray-700 font-medium">{item}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
};

export default UseCases;
